import { CustomInputTextArea } from "../../common/formControls";
import { TEMPLATE_TEXT_MAX_LENGTH } from "./templateTextLimits";

const ConfirmSignature = ({ setPostData, postData, isError = false, errorMessage = "" }) => {

  return (
    <>
      <div className="edit-card p-3" id="signatureEditCard">
        <CustomInputTextArea
            name="signature"
              label="Add Signature Text"
              placeholder="Enter Signature Text"
              required={true}
              isFormControl
              value={postData?.leaseApplicationTemplateSections?.Signature?.clause ?? ""}
              onChange={(e) => { setPostData({ ...postData, leaseApplicationTemplateSections: { ...postData.leaseApplicationTemplateSections, Signature: { ...(postData.leaseApplicationTemplateSections?.Signature ?? {}), clause: e.target.value } } }) }}
              rows={3}
              maxLength={TEMPLATE_TEXT_MAX_LENGTH}
              isError={isError}
              errorMessages={errorMessage}
              myClassName="normal_text "
              width="343px"
        />
      </div>
    </>
  );
};

export default ConfirmSignature;
